/**
 * Chip that indicates a run queue agent state.
 */

import {
  GREEN_300,
  GREEN_600,
  hexToRGB,
  RED_300,
  RED_550,
} from '@wandb/weave/common/css/globals.styles';
import React from 'react';

import {Chip} from '../Chip';
import {QueueStatus} from './queueUtil';

type ActiveChipProps = {
  status: QueueStatus;
};

export const ActiveChip = ({status}: ActiveChipProps) => {
  if (status === 'active') {
    return (
      <Chip
        icon="checkmark-circle"
        label="Active"
        color={GREEN_600}
        backgroundColor={hexToRGB(GREEN_300, 0.48)}
      />
    );
  }
  if (status === 'inactive') {
    return (
      <Chip
        icon="warning"
        label="Not running"
        color={RED_550}
        backgroundColor={hexToRGB(RED_300, 0.48)}
      />
    );
  }
  return null;
};
